import React, { useState } from "react";
import DashboardLeftSection from "../../components/dashboardComponent/DashboardLeftSection";
import "./Dashboard.css";
import { Outlet } from "react-router-dom";
import usePatientStore from "../../store/usePatientStore";
import useUserStore from "../../store/useUserStore";

export default function DashboardLayout() {
    const [patientDetail, setPatientDetail] = useState({
        name: "",
        visitType: "",
        gender: "",
      });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [activeComponent, setActiveComponent] = useState("recording-uploading");
    const {setCurrentSession}=usePatientStore()
    const {user,fetchSessions,setActivePage,fetchSurgicalData} = useUserStore()

    const createNewSession= () => {
        setPatientDetail({ name: "", visitType: "", gender: "" });
        setIsSubmitted(false);
        fetchSessions(user.dentist_id)
        fetchSurgicalData(user.dentist_id)
        setCurrentSession(null)
        setActiveComponent("recording-uploading")
        setActivePage("newSession")
        console.log("creating new session");
      }
  return (
    <div className="dashboard">
      <DashboardLeftSection createNewSession={createNewSession}/>
      <Outlet context={{ patientDetail,setPatientDetail,isSubmitted,setIsSubmitted,activeComponent,setActiveComponent,createNewSession }} />
    </div>
  );
}
